import { createApp } from 'vue';
import App from '@/App.vue';
import './styles.css';
import { router } from './router';

/**
 * 入口（M1-114）。★ 必须先 import router 再 mount：
 * router.ts 里注册了 401 跳转回调，如果只在 App.vue 里按需引入，
 * 首屏请求先于回调注册完成时，会话过期会抛错而不是回登录页。
 */
createApp(App).use(router).mount('#app');
